import { API } from './services/api/api';
import { APIService } from './services/api/api.service';
import { AdminClientEditComponent } from './pages/admin/admin-client-management/admin-client-edit/admin-client-edit.component';
import { AdminClientManagementComponent } from './pages/admin/admin-client-management/admin-client-management.component';
import { AdminHomeComponent } from './pages/admin/admin-home/admin-home.component';
import { AdminOverviewComponent } from './pages/admin/admin-overview/admin-overview.component';
import { AdminService } from './services/api/admin.service';
import { AdminUserEditModalComponent } from './pages/admin/admin-user-management/admin-user-edit-modal/admin-user-edit-modal.component';
import { AdminUserManagementComponent } from './pages/admin/admin-user-management/admin-user-management.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './routes/app-routing.module';
import { AreaCategoriesComponent } from './pages/datasets/area-categories/area-categories.component';
import { AreaCategoryEditComponent } from './pages/datasets/area-category-edit/area-category-edit.component';
import { AreaEditComponent } from './pages/datasets/area-edit/area-edit.component';
import { AreasComponent } from './pages/datasets/areas/areas.component';
import { BidImpressionRateComponent } from './components/charts/booking-reporting/bid-impression-rate/bid-impression-rate.component';
import { BookingOverviewReportingComponent } from './components/charts/booking-reporting/booking-overview-reporting/booking-overview-reporting.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CampaignEditComponent } from './pages/campaigns/bookings/campaign-edit/campaign-edit.component';
import { CampaignsListComponent } from './pages/campaigns/bookings/campaigns-list/campaigns-list.component';
import { CcrHeroComponent } from './components/ccr-hero/ccr-hero.component';
import { CdkTableModule } from '@angular/cdk/table';
import { ChangelogModalComponent } from './services/gui/changelog/changelog-modal/changelog-modal.component';
import { ChangelogService } from './services/gui/changelog/changelog.service';
import { ChannelAirtimeQuotaComponent } from './components/charts/network-reporting/channel-airtime-quota/channel-airtime-quota.component';
import { ChannelDetailsComponent } from './pages/network/channel-details/channel-details.component';
import { ChannelMarkerComponent } from './pages/network/channel-details/channel-marker/channel-marker.component';
import { ChannelOverviewComponent } from './pages/network/channel-details/channel-overview/channel-overview.component';
import { ChannelsComponent } from './pages/network/channels/channels.component';
import { CommercialEditComponent } from './pages/campaigns/bookings/commercial-edit/commercial-edit.component';
import { CommercialsListComponent } from './pages/campaigns/bookings/commercials-list/commercials-list.component';
import { CommonModule } from '@angular/common';
import { CompaniesComponent } from './pages/company/companies/companies.component';
import { CompanyEditComponent } from './pages/company/company-edit/company-edit.component';
import { CompanyInfoComponent } from './components/company-info/company-info.component';
import { CompanyLevelComponent } from './pages/company/company-level/company-level.component';
import { CompanyLevelEditComponent } from './pages/company/company-level-edit/company-level-edit.component';
import { ClientComponent } from './pages/client/client.component';
import { CustomIconsComponent } from './components/custom-icons/custom-icons.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DeviceCreationComponent } from './components/lists/sb-device-list/device-creation/device-creation.component';
import { DeviceDetailsComponent } from './pages/network/device-details/device-details.component';
import { FilterListComponent } from './pages/datasets/filter-list/filter-list.component';
import { DevicesComponent } from './pages/network/devices/devices.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ErrorService } from './services/error.service';
import { FilterEditComponent } from './pages/datasets/filter-edit/filter-edit.component';
import { FilterPipe } from './pipes/filter-pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeoAssetsService } from './services/geo/geo-assets.service';
import { GeoCodingService } from './services/geo/geocoding.service';
import { GeoUtilService } from './services/geo/geoutil.service';
import { HomeComponent } from './pages/home/home.component';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ImpressionsComponent } from './pages/network/location-details/impressions/impressions.component';
import { ErrorHandler, Injector, NgModule } from '@angular/core';
import { LeafletCtrlToZoomDirective } from './components/geo/leaflet-ctrl-to-scroll.directive';
import { LeafletDrawModule } from './directives/leaflet/leaflet-draw.module';
import { LeafletModule } from './directives/leaflet/leaflet.module';
import { LocationDetailsComponent } from './pages/network/location-details/location-details.component';
import { LocationDevicesComponent } from './pages/network/location-details/location-devices/location-devices.component';
import { LocationEditComponent } from './pages/network/locations/location-edit/location-edit.component';
import { LocationOverviewComponent } from './pages/network/location-details/location-overview/location-overview.component';
import { LocationSettingsComponent } from './pages/network/location-details/location-settings/location-settings.component';
import { LocationStatisticsVisitorComponent } from './pages/network/location-details/location-statistics-visitor/location-statistics-visitor.component';
import { LocationsComponent } from './pages/network/locations/locations.component';
import { LoginComponent } from './pages/login/login.component';
import { MapComponent } from './components/geo/map/map.component';
import { MatTableModule } from '@angular/material/table';
import { MediaOverviewComponent } from './pages/media/media-overview/media-overview.component';
import { MediumExplorerComponent } from './pages/media/medium-explorer/medium-explorer.component';
import { MediumGroupsComponent } from './pages/media/medium-groups/medium-groups.component';
import { MediumViewerComponent } from './components/controls/medium-viewer/medium-viewer.component';
import { ModalNavigationDirective } from './services/gui/modal/modal-navigation.directive';
import { ModalService } from './services/gui/modal/modal.service';
import { NetworkAllocationComponent } from './pages/network/network-allocation/network-allocation.component';
import { NetworkOverviewReportingComponent } from './components/charts/network-reporting/network-overview-reporting/network-overview-reporting.component';
import { NetworkShareComponent } from './pages/network/network-share/network-share.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PasswordResetComponent } from './pages/password-reset/password-reset.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { PermissionTranslator } from './pipes/SbPermissionTranslator';
import { DefaultRoleTranslator } from './pipes/SbDefaultRolesTranslator';
import { PlanningComponent } from './pages/campaigns/plannings/planning/planning.component';
import { PlanningEditComponent } from './pages/campaigns/plannings/planning-edit/planning-edit.component';
import { PlanningsListComponent } from './pages/campaigns/plannings/plannings-list/plannings-list.component';
import { PlayerTimeDataComponent } from './components/charts/network-reporting/player-time-data/player-time-data.component';
import { PlayoutsOverallComponent } from './components/charts/booking-reporting/playouts-overall/playouts-overall.component';
import { PlayoutsPerPublisherComponent } from './components/charts/booking-reporting/playouts-per-publisher/playouts-per-publisher.component';
import { PoolsComponent } from './pages/network/pools/pools.component';
import { RequirementBookingAssignmentComponent } from './pages/campaigns/bookings/requirement-booking-assignment/requirement-booking-assignment.component';
import { RequirementEditComponent } from './pages/campaigns/bookings/requirement-edit/requirement-edit.component';
import { RequirementsListComponent } from './pages/campaigns/bookings/requirements-list/requirements-list.component';
import { ReversePipe } from './pipes/reverse-pipe';
import { RouteGuardAdminService } from './services/route-guard-admin.service';
import { RouteGuardService } from './services/route-guard.service';
import { SBTextComponent } from './components/controls/sb-text/sb-text.component';
import { SbActionRequiredComponent } from './components/sb-action-required/sb-action-required.component';
import { SbAreaListComponent } from './components/controls/sb-area-list/sb-area-list.component';
import { SbAreaSelectionComponent } from './components/controls/sb-area-selection/sb-area-selection.component';
import { SbAskModalComponent } from './services/gui/modal/sb-ask-modal/sb-ask-modal.component';
import { SbBookingEditorWrapperComponent } from './components/booking-editor/sb-booking-editor-wrapper/sb-booking-editor-wrapper.component';
import { SbBookingStatusDirective } from './directives/sb-booking-status.directive';
import { SbBoolOperatorComponent } from './components/controls/sb-bool-operator/sb-bool-operator.component';
import { SbCalendarDayComponent } from './components/controls/sb-calendar-day/sb-calendar-day.component';
import { SbCalendarMonthComponent } from './components/controls/sb-calendar-month/sb-calendar-month.component';
import { SbCampaignOverviewComponent } from './components/booking-editor/sb-campaign-overview/sb-campaign-overview.component';
import { SbClusterMapComponent } from './components/geo/sb-cluster-map/sb-cluster-map.component';
import { SbClusterMapLegacyComponent } from './components/geo/sb-cluster-map-legacy/sb-cluster-map-legacy.component';
import { SbCommercialOverviewComponent } from './components/booking-editor/sb-commercial-overview/sb-commercial-overview.component';
import { SbCommercialRowComponent } from './components/booking-editor/sb-commercial-row/sb-commercial-row.component';
import { SbConfirmModalComponent } from './services/gui/modal/sb-confirm-modal/sb-confirm-modal.component';
import { SbCullPreviewComponent } from './components/booking-editor/sb-cull-preview/sb-cull-preview.component';
import { SbCustomModalComponent } from './services/gui/modal/sb-custom-modal/sb-custom-modal.component';
import { SbDatePickerModalComponent } from './services/gui/modal/sb-date-picker-modal/sb-date-picker-modal.component';
import { SbDateTimeRangeViewerComponent } from './components/controls/sb-date-time-range-viewer/sb-date-time-range-viewer.component';
import { SbDeviceDeletionComponent } from './components/lists/sb-device-list/sb-device-deletion/sb-device-deletion.component';
import { SbDeviceLogComponent } from './components/lists/sb-device-list/sb-device-log/sb-device-log.component';
import { SbDeviceOptionsComponent } from './components/lists/sb-device-list/sb-device-options/sb-device-options.component';
import { SbDevicePairingComponent } from './components/lists/sb-device-list/sb-device-pairing/sb-device-pairing.component';
import { SbDevicePlaylistDownloadComponent } from './components/lists/sb-device-list/sb-device-playlist-download/sb-device-playlist-download.component';
import { SbDeviceServiceComponent } from './components/lists/sb-device-list/sb-device-service/sb-device-service.component';
import { SbDropdownBoxComponent } from './components/controls/sb-dropdown-box/sb-dropdown-box.component';
import { SbDropdownTextComponent } from './components/controls/sb-dropdown-text/sb-dropdown-text.component';
import { SbErrorModalComponent } from './services/gui/modal/sb-error-modal/sb-error-modal.component';
import { SbEventTooltipComponent } from './components/booking-editor/sb-event-tooltip/sb-event-tooltip.component';
import { SbFilterDefinitionComponent } from './components/culls/sb-filter-definition/sb-filter-definition.component';
import { SbFilterDefinitionRowComponent } from './components/culls/sb-filter-definition-row/sb-filter-definition-row.component';
import { SbFilterPlayerCullComponent } from './components/culls/sb-filter-player-cull/sb-filter-player-cull.component';
import { SbFilterPreviewComponent } from './components/culls/sb-filter-preview/sb-filter-preview.component';
import { SbFilterTimeCullComponent } from './components/culls/sb-filter-time-cull/sb-filter-time-cull.component';
import { SbFreetextFilteredModalComponent } from './services/gui/modal/sb-freetext-filtered-modal/sb-freetext-filtered-modal.component';
import { SbFreetextModalComponent } from './services/gui/modal/sb-freetext-modal/sb-freetext-modal.component';
import { SbGhostListComponent } from './components/controls/sb-ghost-list/sb-ghost-list.component';
import { SbLocalDateInputComponent } from './components/controls/sb-local-date-input/sb-local-date-input.component';
import { SbLocalDateTimeInputComponent } from './components/controls/sb-local-date-time-input/sb-local-date-time-input.component';
import { SbMapTooltipDirective } from './directives/sb-map-tooltip/sb-map-tooltip.directive';
import { SbMediumDirective } from './directives/sb-medium.directive';
import { SbMediumGroupProxyComponent } from './components/booking-editor/sb-medium-group-proxy/sb-medium-group-proxy.component';
import { SbModalState } from './services/gui/modal/modal-state.service';
import {
  SbModalBodyrDirective,
  SbModalFooterDirective,
  SbModalHeaderDirective,
  SbModalTemplateComponent,
} from './services/gui/modal/sb-modal-template/sb-modal-template.component';
import { SbModalTemplateDirective } from './services/gui/modal/modal.directive';
import { SbModalWrapperComponent } from './services/gui/modal/sb-modal-wrapper/sb-modal-wrapper.component';
import { SbMultiDropdownComponent } from './components/controls/sb-multi-dropdown/sb-multi-dropdown.component';
import { SbMultiFreetextFilteredModalComponent } from './services/gui/modal/sb-multi-freetext-filtered-modal/sb-multi-freetext-filtered-modal.component';
import { SbNavigationModalComponent } from './services/gui/modal/sb-navigation-modal/sb-navigation-modal.component';
import { SbPairingResultComponent } from './components/lists/sb-device-list/sb-pairing-result/sb-pairing-result.component';
import { SbPermissionDirective } from './directives/sb-permission-directive';
import { SbPlanningStatusComponent } from './components/sb-planning-status/sb-planning-status.component';
import { SbPlaylistViewComponent } from './components/sb-playlist-view/sb-playlist-view.component';
import { SbPolygonEditMapComponent } from './components/geo/sb-polygon-edit-map/sb-polygon-edit-map.component';
import { SbPoolListComponent } from './components/sb-pool-list/sb-pool-list.component';
import { SbPreviewListComponent } from './components/lists/sb-preview-list/sb-preview-list.component';
import { SbPreviewTooltipComponent } from './components/sb-preview-tooltip/sb-preview-tooltip.component';
import { SbRadioGroupComponent } from './components/controls/sb-radio-group/sb-radio-group.component';
import { SbSearchSelectModalComponent } from './services/gui/modal/sb-search-select-modal/sb-search-select-modal.component';
import { SbSelectDetailsModalComponent } from './services/gui/modal/sb-select-details-modal/sb-select-details-modal.component';
import { SbSelectModalComponent } from './services/gui/modal/sb-select-modal/sb-select-modal.component';
import { SbSetlistViewComponent } from './components/sb-setlist-view/sb-setlist-view.component';
import { SbSettingsWindowComponent } from './components/sb-settings/sb-settings.component';
import { SbTargetingPreviewComponent } from './components/sb-targeting-preview/sb-targeting-preview.component';
import { SbThreewayToggleButtonComponent } from './components/controls/sb-threeway-toggle-button/sb-threeway-toggle-button.component';
import { SbThreewayToggleCollectionComponent } from './components/controls/sb-threeway-toggle-collection/sb-threeway-toggle-collection.component';
import { SbTimeStatusComponent } from './components/sb-time-status/sb-time-status.component';
import { SbValueDefinitionComponent } from './components/controls/sb-value-definition/sb-value-definition.component';
import { SbVerificationProgressComponent } from './components/sb-verification-progress/sb-verification-progress.component';
import { ScheduleDetailsComponent } from './pages/network/schedule-details/schedule-details.component';
import { ScheduleEditComponent } from './pages/network/schedule-edit/schedule-edit.component';
import { SchedulerComponent } from './components/booking-editor/scheduler-wrapper/scheduler.component';
import { SchedulesAssignmentComponent } from './pages/network/schedules-assignment/schedules-assignment.component';
import { SchedulesComponent } from './pages/network/schedules/schedules.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ServiceTimeDataComponent } from './components/charts/network-reporting/service-time-data/service-time-data.component';
import { StatisticOverviewComponent } from './pages/statistics/statistic-overview/statistic-overview.component';
import { SvgDefinitionsComponent } from './components/custom-icons/svg-definitions/svg-definitions.component';
import { ThreeDimensionalImpressionComponent } from './pages/network/location-details/three-dimensional-impression/three-dimensional-impression.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TruncatePipe } from './pipes/truncate-pipe';
import { UserService } from './services/user.service';
import { UtilService } from './services/util.service';
import { VerificationComponent } from './pages/network/verification/verification.component';
import { createCustomElement } from '@angular/elements';
import { SbDevicePlayoutsComponent } from './components/lists/sb-device-list/sb-device-playouts/sb-device-playouts.component';
import { SbDevicePositionsComponent } from './components/lists/sb-device-list/sb-device-positions/sb-device-positions.component';
import { SbCommercialEditorComponent } from './components/booking-editor/sb-commercial-editor/sb-commercial-editor.component';
import { SbCommercialEditorFormsComponent } from './components/booking-editor/sb-commercial-editor/sb-commercial-editor-forms/sb-commercial-editor-forms.component';
import { AttributesComponent } from './pages/datasets/attributes/attributes.component';
import { AttributeEditComponent } from './pages/datasets/attribute-edit/attribute-edit.component';
import { SbAutofocusDirective } from './directives/sb-autofocus.directive';
import { MediumGroupSettingsEditComponent } from './pages/media/medium-groups/medium-group-settings-edit/medium-group-settings-edit.component';
import { SbBookingEditorSortersComponent } from './components/booking-editor/sb-booking-editor-sorters/sb-booking-editor-sorters.component';
import { PoolEditComponent } from './pages/network/pool-edit/pool-edit.component';
import { SbBookingStatusComponent } from './components/sb-booking-status/sb-booking-status.component';
import { SbMediumGroupOverrideModalComponent } from './services/gui/modal/sb-medium-group-override-modal/sb-medium-group-override-modal.component';
import { SbCommercialConflictListComponent } from './components/booking-editor/sb-commercial-conflict-list/sb-commercial-conflict-list.component';
import { SbCampaignOrderingComponent } from './components/sb-campaign-ordering/sb-campaign-ordering.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { NotificationService } from './services/notifications/notification.service';
import { SbNotificationListComponent } from './components/sb-notification-list/sb-notification-list.component';
import { WebpackTranslateLoader } from './webpack-translate-loader';
import { SbCommercialEditorRequirementsComponent } from './components/booking-editor/sb-commercial-editor/sb-commercial-editor-requirements/sb-commercial-editor-requirements.component';
import { UserProfileComponent } from './pages/user/user-profile/user-profile.component';
import { UserProfileOverviewComponent } from './pages/user/user-profile-overview/user-profile-overview.component';
import { UserProfileSecurityComponent } from './pages/user/user-profile-security/user-profile-security.component';
import { UserProfilePermissionsComponent } from './pages/user/user-profile-permissions/user-profile-permissions.component';
import { UserProfileSettingsComponent } from './pages/user/user-profile-settings/user-profile-settings.component';
import { ToasterComponent } from './services/toaster/toaster/toaster.component';
import { UserProfilePictureUploadComponent } from './pages/user/user-profile/user-profile-picture-upload/user-profile-picture-upload.component';
import { SbCampaignPreviewSliderComponent } from './components/sb-campaign-preview-slider/sb-campaign-preview-slider.component';
import { DeviceDetailsOverviewComponent } from './pages/network/device-details/device-details-overview/device-details-overview.component';
import { DeviceDetailsAttributesComponent } from './pages/network/device-details/device-details-attributes/device-details-attributes.component';
import { DeviceDetailsPlayoutsComponent } from './pages/network/device-details/device-details-playouts/device-details-playouts.component';
// tslint:disable-next-line:max-line-length
import { DeviceDetailsPositionsComponent } from './pages/network/device-details/device-details-positions/device-details-positions.component';
import { DeviceDetailsLogComponent } from './pages/network/device-details/device-details-log/device-details-log.component';
// tslint:disable-next-line:max-line-length
import { DeviceDetailsPlaylistsComponent } from './pages/network/device-details/device-details-playlists/device-details-playlists.component';
import { DeviceDetailsContentShareComponent } from './pages/network/device-details/device-details-content-share/device-details-content-share.component';
import { CompanyDetailsComponent } from './pages/company/company-details/company-details.component';
import { CompanyDetailsOverviewComponent } from './pages/company/company-details/company-details-overview/company-details-overview.component';
import { CompanyDetailsLocationsComponent } from './pages/company/company-details/company-details-locations/company-details-locations.component';
import { CompanyDetailsAttributesComponent } from './pages/company/company-details/company-details-attributes/company-details-attributes.component';
import { SbEmbeddedMediaComponent } from './components/embedded-tables/sb-embedded-media/sb-embedded-media.component';
// tslint:disable-next-line:max-line-length
import { SbEmbeddedMediumGroupsComponent } from './components/embedded-tables/sb-embedded-medium-groups/sb-embedded-medium-groups.component';
import { SbEmbeddedCampaignsComponent } from './components/embedded-tables/sb-embedded-campaigns/sb-embedded-campaigns.component';
import { SbLocationOnlineStatusComponent } from './components/sb-location-online-status/sb-location-online-status.component';
import { CompanyDetailsCampaignsComponent } from './pages/company/company-details/company-details-campaigns/company-details-campaigns.component';
import { CompanyDetailsMediaComponent } from './pages/company/company-details/company-details-media/company-details-media.component';
import { CompanyDetailsMediumGroupsComponent } from './pages/company/company-details/company-details-medium-groups/company-details-medium-groups.component';
import { CompanyDetailsAreasComponent } from './pages/company/company-details/company-details-areas/company-details-areas.component';
import { CompanyDetailsCullsComponent } from './pages/company/company-details/company-details-culls/company-details-culls.component';
import { ChannelDevicesComponent } from './pages/network/channel-details/channel-devices/channel-devices.component';
import { ConversionService } from './services/api/conversion.service';
import { CampaignTypesComponent } from './pages/datasets/campaign-types/campaign-types.component';
import { CampaignTypeEditComponent } from './pages/datasets/campaign-type-edit/campaign-type-edit.component';
import { SbShareOfVoiceComponent } from './pages/statistics/sb-share-of-voice/sb-share-of-voice.component';
import { ShareOfVoiceContentComponent } from './pages/statistics/sb-share-of-voice/share-of-voice-content/share-of-voice-content.component';
import { SbAccessibleClientsComponent } from './components/sb-accessible-clients/sb-accessible-clients.component';
import { FilterOverviewComponent } from './components/filter-overview/filter-overview.component';
import { SbLetDirective } from './directives/sb-let.directive';
import { EnumToArrayPipe } from './pipes/enum-to-array-pipe';
import { SbBooleanTogglesComponent } from './components/controls/sb-boolean-toggles/sb-boolean-toggles.component';
import { SbPaginationComponent } from './components/controls/sb-pagination/sb-pagination.component';
import { UncaughtHandler } from './services/uncaughthandler';
import { SbUncaughtModalComponent } from './services/gui/modal/sb-uncaught-modal/sb-uncaught-modal.component';
import { SbForbiddenModalComponent } from './services/gui/modal/sb-forbidden-modal/sb-forbidden-modal.component';
import { ShareOfVoiceOverviewComponent } from './pages/statistics/sb-share-of-voice/share-of-voice-overview/share-of-voice-overview.component';
import { SbProgressbarWrapperComponent } from './components/sb-progressbar-wrapper/sb-progressbar-wrapper.component';
import { ErrorComponent } from './pages/error/error.component';
import { FilterDetailsComponent } from './pages/datasets/filter-details/filter-details.component';
import { ViewSettingComponent } from './services/view-setting/view-setting/view-setting.component';
import { OrderByPipe } from './pipes/order-by.pipe';
import { AirtimeDataComponent } from './components/charts/network-reporting/airtime-data/airtime-data.component';
import { AirtimeComponent } from './pages/statistics/network/airtime/airtime.component';
import { PlayerReportingComponent } from './pages/statistics/network/player/player-reporting.component';
import { LocationComponent } from './pages/statistics/network/location/location.component';
import { PlayerHeaderComponent } from './pages/statistics/network/player/player-header/player-header.component';
import { AirtimeHeaderComponent } from './pages/statistics/network/airtime/airtime-header/airtime-header.component';
import { LocationHeaderComponent } from './pages/statistics/network/location/location-header/location-header.component';
import { SbChartControlComponent } from './components/charts/sb-chart-control/sb-chart-control.component';
import { SbLocalDateRangeInputComponent } from './components/controls/sb-local-date-range-input/sb-local-date-range-input.component';
import { SbAtomTypeGroupsWrapperComponent } from './components/culls/sb-atom-type-groups-wrapper/sb-atom-type-groups-wrapper.component';
import { DeviceDetailsGeoStatsComponent } from './pages/network/device-details/device-details-geo-stats/device-details-geo-stats.component';
import { NetworkShareEditComponent } from './pages/network/network-share-edit/network-share-edit.component';
import { NetworkShareDetailsComponent } from './pages/network/network-share-details/network-share-details.component';
import { InfoCardComponent } from './components/info-card/info-card.component';
import { SbTagsComponent } from './components/tags/sb-tags/sb-tags.component';
import { SbTagEntitiesComponent } from './components/tags/sb-tag-entities/sb-tag-entities.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { TagsComponent } from './pages/datasets/tags/tags.component';
import { TagEditComponent } from './pages/datasets/tag-edit/tag-edit.component';
import { SbCommentComponentComponent } from './components/discussion/sb-comment-component/sb-comment-component.component';
import { SbAvatarComponent } from './components/sb-avatar/sb-avatar.component';
import { SbDiscussionComponentComponent } from './components/discussion/sb-discussion-component/sb-discussion-component.component';
import { SbDiscussionSubtitleComponent } from './components/discussion/sb-discussion-subtitle/sb-discussion-subtitle.component';
import { SbCompDiscussionMainPostComponent } from './components/discussion/sb-comp-discussion-main-post/sb-comp-discussion-main-post.component';
import { SbDiscussionComponent } from './components/discussion/sb-discussion/sb-discussion.component';
import { SbTopicEditComponent } from './components/discussion/sb-topic-edit/sb-topic-edit.component';
import { ImageCropperComponent } from './components/image/image-cropper/image-cropper.component';
import { ImageUploadComponent } from './components/image/image-upload/image-upload.component';
import { ImageUploadModalComponent } from './services/gui/image/image-upload-modal/image-upload-modal.component';
import { TutorialHighlightComponent } from './services/gui/tutorial/tutorial-highlight/tutorial-highlight.component';
import { TutorialHighlightService } from './services/gui/tutorial/tutorial-highlight.service';
import { ImageUploadService } from './services/gui/image/image-upload.service';
import { SbAggregationReportComponent } from './components/sb-aggregation-report/sb-aggregation-report.component';
import { ProductsComponent } from './pages/datasets/products/products.component';
import { ProductsEditComponent } from './pages/datasets/products-edit/products-edit.component';
import { ProductCategoriesComponent } from './pages/datasets/product-categories/product-categories.component';
import { ProductCategoriesEditComponent } from './pages/datasets/product-categories-edit/product-categories-edit.component';
import { ProductDetailsComponent } from './pages/datasets/product-details/product-details.component';
import { ProductDetailsOverviewComponent } from './pages/datasets/product-details/product-details-overview/product-details-overview.component';
import { ProductDetailsAttributesComponent } from './pages/datasets/product-details/product-details-attributes/product-details-attributes.component';
import { ProductDetailsCategoriesComponent } from './pages/datasets/product-details/product-details-categories/product-details-categories.component';
import { MediumTemplatePreviewComponent } from './pages/media/medium-template-preview/medium-template-preview.component';
import { SafePipe } from './pipes/safe-pipe';
import { SbFilterClientCullComponent } from './components/culls/sb-filter-client-cull/sb-filter-client-cull.component';
import { TemplateGroupsComponent } from './pages/media/templateGroup/template-groups.component';
import { TemplateGroupEditComponent } from './pages/media/templateGroup/templateGroup-edit/template-group-edit.component';
import { EmailEditorModule } from './addons/unlayer/angular-email-editor/email-editor.module';
import { ContentEditorListComponent } from './pages/media/content-editor-list/content-editor-list.component';
import { ContentEditorComponent } from './pages/media/content-editor/content-editor.component';
import { ContentEditorService } from './services/content-editor/content-editor.service';
import { ContentCreatorComponent } from './pages/media/content-creator/content-creator.component';
import { SbBookableMarkersComponent } from './components/sb-bookable-markers/sb-bookable-markers.component';
import { PlayerHardwareComponent } from './pages/datasets/player-hardware/player-hardware.component';
import { PlayerSoftwareComponent } from './pages/datasets/player-software/player-software.component';
import { TemplateSourceComponent } from './pages/media/template-source/template-source.component';
import { TemplateSourceEditComponent } from './pages/media/template-source/template-source-edit/template-source-edit.component';
import {
  SbFilterPanelWrapperDirective,
  SbFooterMoreWrapperDirective,
  SbTableWrapperNewComponent,
} from './components/sb-table-wrapper/table-wrapper-new/sb-table-wrapper-new.component';
import { SbHeaderMoreWrapperDirective, SbTableWrapperComponent } from './components/sb-table-wrapper/sb-table-wrapper.component';
import { AdminClientAdminManagementModalComponent } from './pages/admin/admin-client-management/admin-client-admin-management-modal/admin-client-admin-management-modal.component';
import { AdminClientAdminAddModalComponent } from './pages/admin/admin-client-management/admin-client-admin-add-modal/admin-client-admin-add-modal.component';
import { TemplateSourceEntriesComponent } from './pages/media/template-source-entries/template-source-entries.component';
import { TemplateSourceEntryEditComponent } from './pages/media/template-source-entries/template-source-entry-edit/template-source-entry-edit.component';
import { QueryParamService } from './services/lists/query-params';
import { MediumCardEntryComponent } from './pages/media/medium-explorer/medium-entry/medium-card-entry/medium-card-entry.component';
import { MediumEditComponent } from './pages/media/medium-explorer/medium-edit/medium-edit.component';
import { ImageViewerComponent } from './components/controls/image-viewer/image-viewer.component';
import {
  SbLevelDropdownComponent,
  SbLevelDropdownFooterDirective,
  SbLevelDropdownHeaderDirective,
} from './components/sb-level-dropdown/sb-level-dropdown.component';
import { SbFilterGeoCullComponent } from './components/culls/sb-filter-geo-cull/sb-filter-geo-cull.component';
import { SbTableButtonsComponent } from './components/sb-table-wrapper/sb-table-buttons/sb-table-buttons.component';
import { MediumGroupEditComponent } from './pages/media/medium-groups/medium-group-edit/medium-group-edit.component';
import { SbPricingModalComponent } from './components/sb-pricing-modal/sb-pricing-modal.component';
import { SbPlaylistPreviewComponent } from './components/sb-playlist-view/sb-playlist-preview/sb-playlist-preview.component';
import { SSPContractsComponent } from './pages/datasets/sspcontracts/sspContracts.component';
import { DealsComponent } from './pages/datasets/deals/deals.component';
import { SSPContractCreationComponent } from './components/sspcontract-creation/sspContract-creation.component';
import { DealCreationComponent } from './components/deal-creation/deal-creation.component';
import { SSPSComponent } from './pages/datasets/ssps/ssps.component';
import { TrackerComponent } from './pages/network/tracker/tracker.component';
import { TrackerCreationComponent } from './components/tracking/tracker-creation/tracker-creation.component';
import { TrackerDetailsComponent } from './pages/network/tracker-details/tracker-details.component';
import { TrackerDetailsTrackedVisitorsComponent } from './pages/network/tracker-details/tracker-details-tracked-visitors/tracker-details-tracked-visitors.component';
import { TrackerDetailsOverviewComponent } from './pages/network/tracker-details/tracker-details-overview/tracker-details-overview.component';
import { LocationTrackerComponent } from './pages/network/location-details/location-tracker/location-tracker.component';
import { VisitorTrackerChartComponent } from './components/charts/network-reporting/visitor-tracker-chart/visitor-tracker-chart.component';
import { SbBookingEditorMediumSelectionComponent } from './components/booking-editor/sb-booking-editor-medium-selection/sb-booking-editor-medium-selection.component';
import { InventoryWrapperComponent } from './pages/inventory/inventory-wrapper/inventory-wrapper.component';
import { InventoryCartComponent } from './pages/inventory/inventory-cart/inventory-cart.component';
import { InventoryListComponent } from './pages/inventory/inventory-list/inventory-list.component';
import { InventorySublistComponent } from './pages/inventory/inventory-sublist/inventory-sublist.component';
import { InventoryDetailsComponent } from './pages/inventory/inventory-details/inventory-details.component';
import { InventoryScopeSelectComponent } from './pages/inventory/inventory-scope-select/inventory-scope-select.component';
import { NetworkBookingsListComponent } from './pages/network/network-bookings-list/network-bookings-list.component';
import { SbDropdownSelectComponent } from './components/dropdown-select/sb-dropdown-select.component';
import { SbStringDropdownSelectComponent } from './components/string-dropdown-select/sb-string-dropdown-select.component';
import { SbMarkerListComponent } from './components/sb-marker-list/sb-marker-list.component';
import { ScheduleLevelEditComponent } from './pages/network/schedule-level-edit/schedule-level-edit.component';
import { TrackerValuesElementComponent } from './components/tracking/tracker-values-element/tracker-values-element.component';
import { TrackerValuesElementEditComponent } from './components/tracking/tracker-values-element-edit/tracker-values-element-edit.component';
import { TrackerValuesLineComponent } from './components/tracking/tracker-values-line/tracker-values-line.component';
import { PlayerHardwareEditComponent } from './pages/datasets/player-hardware-edit/player-hardware-edit.component';
import { PlayerSoftwareEditComponent } from './pages/datasets/player-software-edit/player-software-edit.component';
import { PlayerHardwareDetailsComponent } from './pages/datasets/player-hardware-details/player-hardware-details.component';
import { PlayerHardwareDetailsOverviewComponent } from './pages/datasets/player-hardware-details/player-hardware-details-overview/player-hardware-details-overview.component';
import { ScreenHardwareComponent } from './pages/datasets/screen-hardware/screen-hardware.component';
import { ScreenHardwareEditComponent } from './pages/datasets/screen-hardware-edit/screen-hardware-edit.component';
import { SbDeviceOnlineStatusCardComponent } from './components/sb-device-status/sb-device-online-status-card/sb-device-online-status-card.component';
import { SbDeviceOnlineStatusComponent } from './components/sb-device-status/sb-device-online-status/sb-device-online-status.component';
import { SbDeviceOnlineStatusIconComponent } from './components/sb-device-status/sb-device-online-status-icon/sb-device-online-status-icon.component';
import { SbImageNameWrapperComponent } from './components/name-wrapper/sb-image-name-wrapper/sb-image-name-wrapper.component';
import {
  SbFifthLineDirective,
  SbFirstLineDirective,
  SbFourthLineDirective,
  SbNameWrapperComponent,
  SbSecondLineDirective,
  SbThirdLineDirective,
} from './components/name-wrapper/sb-name-wrapper/sb-name-wrapper.component';
import { SbLinkComponent } from './components/sb-link/sb-link.component';
import { SbMediumComponent } from './components/medium/sb-medium.component';
import { AttachmentExplorerComponent } from './pages/datasets/attachment-explorer/attachment-explorer.component';
import { SbSidePanelComponent } from './components/sb-side-panel/sb-side-panel.component';
import { AttachmentEditComponent } from './pages/datasets/attachment-explorer/attachment-edit/attachment-edit.component';
import { AttachmentLinkComponent } from './pages/datasets/attachment-explorer/attachment-link/attachment-link.component';
import { LocationAttachmentsComponent } from './pages/network/location-details/location-attachments/location-attachments.component';
import { AttachmentUrlComponent } from './pages/datasets/attachment-explorer/attachment-edit/attachment-url/attachment-url.component';
import { AttachmentPreviewComponent } from './pages/datasets/attachment-explorer/attachment-preview/attachment-preview.component';
import { FileDummyComponent } from './components/file-dummy/file-dummy.component';
import { AttachmentUploadComponent } from './pages/datasets/attachment-explorer/attachment-upload/attachment-upload.component';
import { FileUploadComponent } from './components/upload/file-upload/file-upload.component';
import { AttachmentCardEntryComponent } from './pages/datasets/attachment-explorer/attachment-entry/attachment-card-entry/attachment-card-entry.component';
import { LocationTrackerAssignmentComponent } from './pages/network/location-details/location-tracker-assignment/location-tracker-assignment.component';
import { LocationTrackerAssignmentToScreensComponent } from './pages/network/location-details/location-tracker-assignment/location-tracker-assignment-to-screens/location-tracker-assignment-to-screens.component';
import { TrackerStatusComponent } from './components/tracking/tracker-status/tracker-status.component';
import { LocationTrackerAssignmentToTrackerComponent } from './pages/network/location-details/location-tracker-assignment/location-tracker-assignment-to-tracker/location-tracker-assignment-to-tracker.component';
import { GeneratedReportsComponent } from './pages/statistics/standardReporting/generated-reports/generated-reports.component';
import { SbTagLookupsComponent } from './components/tags/sb-tag-lookups/sb-tag-lookups.component';
import { AttachmentFileComponent } from './pages/datasets/attachment-explorer/attachment-edit/attachment-file/attachment-file.component';
import { AttachmentListEntryComponent } from './pages/datasets/attachment-explorer/attachment-entry/attachment-list-entry/attachment-list-entry.component';
import { DeviceAttachmentsComponent } from './pages/network/device-details/device-attachments/device-attachments.component';
import { AttachmentUrlUploadComponent } from './pages/datasets/attachment-explorer/attachment-upload/attachment-url-upload/attachment-url-upload.component';
import { SbDiscussionMentionsComponent } from './components/discussion/sb-discussion-mentions/sb-discussion-mentions.component';
import { DeviceService } from './services/device/deviceService';
import { SbDeviceRebootComponent } from './components/lists/sb-device-list/sb-device-reboot/sb-device-reboot.component';
import { SbDeviceExitPlayerComponent } from './components/lists/sb-device-list/sb-device-exit-player/sb-device-exit-player.component';
import { AdminUserSetRestoreCodeComponent } from './pages/admin/admin-user-management/admin-user-set-restore-code/admin-user-set-restore-code.component';
import { SbLocalDateTimeRangeInputComponent } from './components/controls/sb-local-date-time-range-input/sb-local-date-time-range-input.component';
import { NoticeBoxComponent } from './components/noticebox/notice-box.component';
import { QueryPerformanceComponent } from './pages/admin/performance/query/query-performance.component';
import { EndpointPerformanceComponent } from './pages/admin/performance/endpoint/endpoint-performance.component';
import { SbPasswordRequirementComponent } from './components/sb-password-requirement/sb-password-requirement.component';
import { SbPlanningCommercialComponent } from './components/booking-editor/sb-planning-commercial/sb-planning-commercial.component';
import { SbPartialPlanningComponent } from './components/booking-editor/partial-planning/sb-partial-planning.component';
import { SbPlanningTimeComponent } from './components/booking-editor/sb-planning-time/sb-planning-time.component';
import { SbPeakChartComponent } from './components/charts/sb-peak-chart/sb-peak-chart.component';
import { StatisticCardComponent } from './components/statistic-card/statistic-card.component';
import { UploadingElementComponent } from './services/upload/uploading-element/uploading-element.component';
import { SbCountrySelectComponent } from './components/address/sb-country-select/sb-country-select.component';
import { AddressComponentComponent } from './components/address/address-component/address-component.component';
import { ClientSelectionComponent } from './components/client-selection/client-selection.component';
import { ColorsComponent } from './pages/datasets/colors/colors.component';
import { ColorEditComponent } from './pages/datasets/colors/edit/color-edit.component';
import { WeeklyScheduleListComponent } from './pages/datasets/weekly-cycle-list/weekly-schedule-list.component';
import { WeeklyScheduleEditComponent } from './pages/datasets/weekly-cycle-list/weekly-cycle-edit/weekly-schedule-edit.component';
import { WeeklyScheduleComponent } from './components/sb-weekly-cycle/weekly-schedule.component';
import { SbSpecialOpeningHoursInputComponent } from './components/sb-special-opening-hours-input/sb-special-opening-hours-input.component';
import { SbTimeInputComponent } from './components/sb-time-input/sb-time-input.component';
import { TimeTypesComponent } from './pages/datasets/time-types/time-types.component';
import { TimeTypeEditComponent } from './pages/datasets/time-types/time-type-edit/time-type-edit.component';
import { ReportingFileComponent } from './components/standard-reporting/reporting-file/reporting-file.component';
import { ReportingModalComponent } from './components/standard-reporting/reporting-modal/reporting-modal.component';
import { GeneratedReportsListComponent } from './components/standard-reporting/generated-reports-list/generated-reports-list.component';
import { ClientOverviewComponent } from './pages/client/overview/client-overview.component';
import { ClientUserManagementComponent } from './pages/client/user-management/client-user-management.component';
import { ClientRoleManagementComponent } from './pages/client/role-management/client-role-management.component';
import { ClientInvitationsComponent } from './pages/client/invitations/client-invitations.component';
import { WebSettingsComponent } from './pages/client/settings/web-settings.component';
import { ClientConnectionsComponent } from './pages/client/connections/client-connections.component';
import { ConnectClientComponent } from './pages/connect-client/connect-client.component';
import { MediumListEntryComponent } from './pages/media/medium-explorer/medium-entry/medium-list-entry/medium-list-entry.component';
import { MediumUploadComponent } from './pages/media/medium-explorer/medium-upload/medium-upload.component';
import { SbCommercialCountComponent } from './components/sb-commercial-count/sb-commercial-count.component';
import { WebSettingComponent } from './components/client/settings/client-setting/web-setting.component';
import { CreateClientConnectionComponent } from './pages/client/connections/create/create-client-connection.component';
import { IncomingClientConnectionsTableComponent } from './components/client/connections/incoming/client-connections-incomming-table.component';
import { SendClientConnectionsTableComponent } from './components/client/connections/send/send-client-connections-table.component';
import { RepositoriesListComponent } from './pages/assets/datasets/repositories-list/repositories-list.component';
import { AssetListComponent } from './pages/assets/datasets/asset-list/asset-list.component';
import { AssetEditComponent } from './pages/assets/datasets/asset-edit/asset-edit.component';
import { RepositoriesEditComponent } from './pages/assets/datasets/repositories-edit/repositories-edit.component';
import { AssetCategoryListComponent } from './pages/assets/datasets/asset-category-list/asset-category-list.component';
import { AssetCategoryEditComponent } from './pages/assets/datasets/asset-category-edit/asset-category-edit.component';
import { SelectionComponent } from './components/selection/selection.component';
import { AssetExplorerComponent } from './pages/assets/shared/asset-explorer/asset-explorer.component';
import { AdminClientLicencesComponent } from './pages/admin/admin-client-licence-management/admin-client-licences.component';
// tslint:disable-next-line:max-line-length
import { LicenceManagementGenerateModalComponent } from './pages/admin/admin-client-licence-management/modals/generate-licences/licence-management-generate-modal.component';
// tslint:disable-next-line:max-line-length
import { LicenceManagementCopySerialModalComponent } from './pages/admin/admin-client-licence-management/modals/copy-serial/licence-management-copy-serial-modal.component';
// tslint:disable-next-line:max-line-length
import { LicenceManagementAutoAssignModalComponent } from './pages/admin/admin-client-licence-management/modals/auto-assign/auto-assign-modal.component';
import { SbClipboardListInputModalComponent } from './components/sb-clipboard-list-input-modal/sb-clipboard-list-input-modal.component';
import { SbClipboardListInputComponent } from './components/sb-clipboard-list-input/sb-clipboard-list-input.component';

import { CalendarModule } from '@ngx-seatback/calendar';
import {
  BreadcrumbModule,
  ButtonModule,
  ButtonPrimaryModule,
  ButtonSecondaryModule,
  DatePickerModule,
  LoadingSpinnerModule,
  ScrollTopButtonModule,
  SearchBarModule,
  ThemingControlModule,
  ThemingWrapperModule,
  ToggleModule,
  SelectModule,
  SegmentControlModule,
  PaginationModule,
  SplitButtonModule,
  DropdownModule,
  BoxModule,
  ButtonDropdownModule,
  SlideshowModule,
  ActionBarModule,
} from '@ngx-seatback/controls';
import {
  AutofocusModule,
  DelayedHoverModule,
  EventResizeModule,
  PipeModule,
  RouterLinkActiveModule,
  RouterLinkModule,
  TooltipModule,
} from '@ngx-seatback/utils';
import { IconModule, ICONS_IMPORT, IconService } from '@ngx-seatback/icons';
import {
  CardModule,
  FooterModule,
  FrontpageModule,
  LoginModule,
  PasswordResetModule,
  MegaNavbarModule,
  SbCardLoadingSpinnerModule,
  SbWizardModule,
  StepperModule,
  FilterModule,
  TableCardModule,
} from '@ngx-seatback/layout';
import { ChartModule, ChartWrapperModule, LineSmallChartModule, SankeyChartModule, HeatmapStatusChartModule } from '@ngx-seatback/charts';
import { SbPageActionService } from './services/page-action/sb-page-action.service';
import { SbPageActionDirective } from './directives/page-action/sb-page-action.directive';
import { SbPageActionComponent } from './directives/page-action/sb-page-action/sb-page-action.component';
import { SbToggleSwitchComponent } from './components/sb-toggle-switch/sb-toggle-switch.component';
import { SbProgressbarComponent } from './components/sb-progressbar/sb-progressbar.component';
import { SbInfoTextComponent } from './components/sb-info-text/sb-info-text.component';
import { DebugVersionComponent } from './pages/debug/debug-version/debug-version.component';
import { ReservationListComponent } from './pages/reservations/reservation-list/reservation-list.component';
import { ReservationComponent } from './pages/reservations/reservation/reservation.component';
import { ReservationEditComponent } from './pages/reservations/reservation-edit/reservation-edit.component';
import { SbExportModalComponent } from './services/gui/modal/sb-export-modal/sb-export-modal.component';
import { SbDateTimeRangeInputComponent } from './components/controls/sb-date-time-range-input/sb-date-time-range-input.component';
import { AssetConversionModalComponent } from './pages/assets/shared/asset-conversion-modal/asset-conversion-modal.component';
import { SbFilterContentCullComponent } from './components/culls/sb-filter-content-cull/sb-filter-content-cull.component';
import { SlotOrderComponent } from './components/slot-order-component/slot-order.component';
import { SbNetworkShareOptionStatusComponent } from './components/sb-table-wrapper/sb-network-share-option-status/sb-network-share-option-status.component';
import { SbTemplateDataSetSelectModalComponent } from './pages/campaigns/bookings/requirement-booking-assignment/template-source-select-modal/sb-template-data-set-select-modal.component';
import { SharedAssetComponent } from './pages/assets/shared/shared-asset/shared-asset.component';
import { RoleEditModalComponent } from './pages/client/role-management/edit/role-edit-modal.component';
import { CullCategoriesComponent } from './pages/datasets/filter-categories/cull-categories.component';
import { CullCategoryEditComponent } from './pages/datasets/filter-categories-edit/cull-category-edit.component';
import { TemplateDatasetComponent } from './pages/media/template-dataset/template-dataset.component';
import { TemplateDatasetEditComponent } from './pages/media/template-dataset/template-dataset-edit/template-dataset-edit.component';
import { TemplateDatasetEntriesComponent } from './pages/media/template-dataset-entries/template-dataset-entries.component';
import { TemplateDatasetEntryEditComponent } from './pages/media/template-dataset-entries/template-dataset-entry-edit/template-dataset-entry-edit.component';
import { ClientUserEditModalComponent } from './pages/client/user-management/edit/client-user-edit-modal.component';
import { DeviceDetailsScreensComponent } from './pages/network/device-details/device-details-screens/device-details-screens.component';
import { PlaylistSchemaComponent } from './components/sb-playlist-view/playlist-schema-iteration/playlist-schema.component';
import { TargetingComponent } from './pages/targeting/targeting/targeting.component';
import { TargetingEditComponent } from './pages/targeting/targeting-edit/targeting-edit.component';
import { TargetingOverviewComponent } from './pages/targeting/targeting-overview/targeting-overview.component';
import { SbDeviceLocalDataComponent } from './components/lists/sb-device-list/sb-device-local-data/sb-device-local-data.component';
import { SbDeviceLocalSettingComponent } from './components/lists/sb-device-list/sb-device-local-setting/sb-device-local-setting.component';
import { SbDeviceCalibrationComponent } from './components/lists/sb-device-list/sb-device-calibration/sb-device-calibration.component';
import { MediumTransformationListComponent } from './pages/network/medium-transformation-list/medium-transformation-list.component';
import { TargetedBookingSetComponent } from './components/sb-playlist-view/targeted-booking-set/targeted-booking-set.component';
import { RenderedTemplatesComponent } from './components/screens/rendered-templates/rendered-templates.component';
import { RenderedGroupsComponent } from './components/screens/rendered-groups/rendered-groups.component';
import { httpInterceptorProviders } from './services_helper/auth.interceptor';
import { AggregatedPlaylistSchemaComponent } from './components/sb-playlist-view/aggregated-playlist-schema-iteration/aggregated-playlist-schema.component';
import { AdminMembershipComponent } from './pages/admin/admin-membership/admin-membership.component';
import { PlayoutAggregationComponent } from './components/playout-aggregation/playout-aggregation.component';
import { DropdownSelectItemComponent } from './components/dropdown-select/dropdown-select-item/dropdown-select-item.component';
import { QuotasComponent } from './components/quotas/quotas/quotas.component';
import { ContentShareComponent } from './pages/campaigns/content-share/content-share.component';
import { SingleQuotaComponent } from './components/quotas/single-quota/single-quota.component';
import { ContentShareEditComponent } from './pages/campaigns/content-share/content-share-edit/content-share-edit.component';
import { SbPlanningContentShareComponent } from './components/sb-planning-content-share/sb-planning-content-share.component';
import { ValidityRangeDisplayComponent } from './components/validity-range-display/validity-range-display.component';
import { SubmissionCountDisplayComponent } from './components/submission-count-display/submission-count-display.component';
import { MediumGroupCategoryListComponent } from './pages/media/medium-groups/mediumGroup-category-list/medium-group-category-list.component';
import { MediumGroupCategoryEditComponent } from './pages/media/medium-groups/mediumGroup-category-edit/medium-group-category-edit.component';
import { AdvertiserShareOfVoiceComponent } from './pages/statistics/sb-share-of-voice/advertiser-share-of-voice/advertiser-share-of-voice.component';
import { BackgroundWorkerComponent } from './pages/admin/admin-backgroundworker/background-worker.component';
import { SbMultiSelectModalComponent } from './services/gui/modal/sb-multi-select-modal/sb-multi-select-modal.component';
import { ApiKeyListComponent } from './pages/client/api-key-list/api-key-list.component';
import { ApiKeyEditComponent } from './pages/client/api-key-list/medium-group-settings-edit/api-key-edit.component';
import { SbDevicePlaylistCache } from './components/lists/sb-device-list/sb-device-playlist-cache/sb-device-playlist-cache.component';
import { SharedContentSharesComponent } from './components/quotas/SharedContentShare/shared-content-shares.component';
import { DeviceDetailsSetlistsComponent } from './pages/network/device-details/device-details-setlists/device-details-setlists.component';
import { DeviceDetailsPlaybackScheduleComponent } from './pages/network/device-details/device-details-playback-schedule/device-details-playback-schedule.component';
import { SharedPlaybackSchedulesComponent } from './components/SharedPlaybackSchedules/shared-playback-schedules.component';
import { DeviceDetailsActivityComponent } from './pages/network/device-details/device-details-activity/device-details-activity.component';
import { HeatmapStatusComponent } from './components/charts/heatmap-status/heatmap-status.component';
import { DisplayCreatedComponent } from './components/table-last-changes/display-created/display-created.component';
import { DisplayModifiedComponent } from './components/table-last-changes/display-modified/display-modified.component';
import { SharedNetworkAccessComponent } from './components/SharedNetworkAccess/shared-network-access.component';
import { DeviceDetailsNetworkAccessComponent } from './pages/network/device-details/device-details-network-access/device-details-network-access.component';
import { NetworkBookingsComponent } from './pages/network/network-bookings/network-bookings.component';
import { DeviceDetailsNetworkBookingsComponent } from './pages/network/device-details/device-details-network-bookings/device-details-network-bookings.component';
import { RoutingTestComponent } from './components/testing/routing/routing-test.component';
import { CampaignReportingService } from './services/campaign-reporting.service';
import { AttachmentService } from './services/attachment.service';
import { BookingService } from './services/booking.service';
import { CommercialReservationService } from './services/commercial-reservation.service';
import { FilterStorageService } from './services/filter-storage.service';
import { TitleStrategy } from '@angular/router';
import { SbPageTitleStrategy } from './services/TemplatePageTitleStrategy.service';
import { StorageService } from './services/storage.service';
import { UserSettingStorageService } from './services/user-setting-storage.service';
import { UserSettingService } from './services/user-setting.service';
import { StringTransformationService } from './services/transformation-helper/string-transformation.service';
import { DateTransformationService } from './services/transformation-helper/date-transformation.service';
import { DynamicTableElementComponent } from './components/dynamic-table-elements/dynamic-table-element.component';
import { TableMultiSelectButtonComponent } from './components/table-multi-select-button/table-multi-select-button.component';
import { OmitPipe } from './pipes/omit-pipe';
import { ColumnOptionComponent } from './components/identity-ordering/column-option.component';
import { CampaignReportingObsService } from './services/campaign-reporting-obs.service';
import { TableSelectButtonComponent } from './components/table-select-button/table-select-button.component';
import { KiComponent } from './components/ki/ki-modal/ki.component';
import { KiHistoryComponent } from './components/ki/ki-history/ki-history.component';
import { KiService } from './components/ki/ki.service';
import { AiAPI } from './services/api/aiApi';
import { AiAPIService } from './services/api/aiApi.service';

const DIRECTIVES = [
  LeafletCtrlToZoomDirective,
  ModalNavigationDirective,
  SbBookingStatusDirective,
  SbMapTooltipDirective,
  SbMediumDirective,
  SbModalBodyrDirective,
  SbModalFooterDirective,
  SbModalHeaderDirective,
  SbModalTemplateDirective,
  SbPermissionDirective,
  SbAutofocusDirective,
  SbLetDirective,
  SbHeaderMoreWrapperDirective,
  SbFilterPanelWrapperDirective,
  SbLevelDropdownHeaderDirective,
  SbLevelDropdownFooterDirective,
  SbFooterMoreWrapperDirective,
  SbFirstLineDirective,
  SbSecondLineDirective,
  SbThirdLineDirective,
  SbFourthLineDirective,
  SbFifthLineDirective,
  SbPageActionDirective,
];

const PIPES = [FilterPipe, PermissionTranslator, DefaultRoleTranslator, ReversePipe, TruncatePipe, EnumToArrayPipe, SafePipe, OmitPipe];

const PAGES = [
  AdminClientManagementComponent,
  AdminHomeComponent,
  AdminOverviewComponent,
  AdminUserManagementComponent,
  AreaCategoriesComponent,
  AreaCategoryEditComponent,
  AreaEditComponent,
  AreasComponent,
  CampaignEditComponent,
  CampaignsListComponent,
  ChannelDetailsComponent,
  ChannelMarkerComponent,
  ChannelOverviewComponent,
  ChannelsComponent,
  CommercialEditComponent,
  CommercialsListComponent,
  CompaniesComponent,
  CompanyEditComponent,
  CompanyInfoComponent,
  CompanyLevelComponent,
  CompanyLevelEditComponent,
  ClientComponent,
  DashboardComponent,
  TemplateGroupEditComponent,
  DeviceDetailsComponent,
  FilterListComponent,
  DevicesComponent,
  HomeComponent,
  ImpressionsComponent,
  LocationDetailsComponent,
  LocationDevicesComponent,
  LocationEditComponent,
  LocationOverviewComponent,
  LocationSettingsComponent,
  LocationStatisticsVisitorComponent,
  LocationsComponent,
  LoginComponent,
  MediaOverviewComponent,
  MediumExplorerComponent,
  MediumGroupEditComponent,
  MediumGroupsComponent,
  NetworkAllocationComponent,
  NetworkBookingsComponent,
  NetworkShareComponent,
  PasswordResetComponent,
  PlanningComponent,
  PlanningEditComponent,
  PlanningsListComponent,
  PoolsComponent,
  RequirementEditComponent,
  RequirementsListComponent,
  ScheduleDetailsComponent,
  ScheduleEditComponent,
  SchedulesAssignmentComponent,
  SchedulesComponent,
  StatisticOverviewComponent,
  ThreeDimensionalImpressionComponent,
  VerificationComponent,
  ChannelDevicesComponent,
];

const CONTROLS = [
  ButtonPrimaryModule,
  ButtonSecondaryModule,
  CardModule,
  BreadcrumbModule,
  ButtonModule,
  ButtonDropdownModule,
  ScrollTopButtonModule,
  SearchBarModule,
  ThemingWrapperModule,
  ThemingControlModule,
  SbWizardModule,
  DatePickerModule,
  LoadingSpinnerModule,
  ToggleModule,
  SelectModule,
  SegmentControlModule,
  PaginationModule,
  SplitButtonModule,
  DropdownModule,
  BoxModule,
  SlideshowModule,
  ActionBarModule,
];

const LAYOUT = [
  FooterModule,
  FrontpageModule,
  MegaNavbarModule,
  LoginModule,
  PasswordResetModule,
  StepperModule,
  FilterModule,
  TableCardModule,
  SbCardLoadingSpinnerModule,
];

const CHARTS = [LineSmallChartModule, ChartModule, ChartWrapperModule, SankeyChartModule, HeatmapStatusChartModule];

const UTILS = [RouterLinkModule, RouterLinkActiveModule, PipeModule, DelayedHoverModule, AutofocusModule, TooltipModule, EventResizeModule];

const CALENDAR = [CalendarModule];

const LIB_ENTRY = [CONTROLS, LAYOUT, CHARTS, CALENDAR, UTILS];

const MODALS_ENTRY = [
  ChangelogModalComponent,
  DeviceCreationComponent,
  SbDateTimeRangeViewerComponent,
  SbDeviceOptionsComponent,
  SbDevicePairingComponent,
  SbDevicePlaylistDownloadComponent,
  SbDeviceServiceComponent,
  SbPairingResultComponent,
  AdminUserEditModalComponent,
  AdminClientEditComponent,
  AdminClientAdminManagementModalComponent,
  AdminClientAdminAddModalComponent,
  AssetConversionModalComponent,
];

const MODAL_COMPONENTS_ENTRY = [SbNavigationModalComponent];

const MODALS = [MODALS_ENTRY, SbErrorModalComponent];

const MODAL_COMPONENTS = [
  MODAL_COMPONENTS_ENTRY,
  SbAskModalComponent,
  SbConfirmModalComponent,
  SbCustomModalComponent,
  SbDatePickerModalComponent,
  SbFreetextFilteredModalComponent,
  SbFreetextModalComponent,
  SbMultiFreetextFilteredModalComponent,
  SbModalWrapperComponent,
  SbSearchSelectModalComponent,
  SbSelectDetailsModalComponent,
  SbSelectModalComponent,
  SbMultiSelectModalComponent,
  SbModalTemplateComponent,
];

const COMPONENTS = [
  BidImpressionRateComponent,
  BookingOverviewReportingComponent,
  CcrHeroComponent,
  ChannelAirtimeQuotaComponent,
  CustomIconsComponent,
  FilterEditComponent,
  MapComponent,
  MediumViewerComponent,
  NetworkOverviewReportingComponent,
  PlayerTimeDataComponent,
  PlayoutsOverallComponent,
  PlayoutsPerPublisherComponent,
  RequirementBookingAssignmentComponent,
  SBTextComponent,
  SbActionRequiredComponent,
  SbAreaListComponent,
  SbAreaSelectionComponent,
  SbBookingEditorWrapperComponent,
  SbBoolOperatorComponent,
  SbCalendarDayComponent,
  SbCalendarMonthComponent,
  SbCampaignOverviewComponent,
  SbClusterMapComponent,
  SbClusterMapLegacyComponent,
  SbCommercialOverviewComponent,
  SbCommercialRowComponent,
  SbCullPreviewComponent,
  SbDeviceDeletionComponent,
  SbDeviceLogComponent,
  SbDevicePlayoutsComponent,
  SbDevicePositionsComponent,
  SbDropdownBoxComponent,
  SbDropdownTextComponent,
  SbEventTooltipComponent,
  SbFilterDefinitionComponent,
  SbFilterDefinitionRowComponent,
  SbFilterPlayerCullComponent,
  SbFilterClientCullComponent,
  SbFilterPreviewComponent,
  SbFilterTimeCullComponent,
  SbGhostListComponent,
  SbLocalDateInputComponent,
  SbLocalDateTimeInputComponent,
  SbMediumGroupProxyComponent,
  SbMultiDropdownComponent,
  SbPlanningStatusComponent,
  SbPlaylistViewComponent,
  SbPolygonEditMapComponent,
  SbPoolListComponent,
  SbPreviewListComponent,
  SbPreviewTooltipComponent,
  SbRadioGroupComponent,
  SbSetlistViewComponent,
  SbSettingsWindowComponent,
  SbTargetingPreviewComponent,
  SbThreewayToggleButtonComponent,
  SbThreewayToggleCollectionComponent,
  SbTimeStatusComponent,
  SbValueDefinitionComponent,
  SbVerificationProgressComponent,
  SchedulerComponent,
  ServiceTimeDataComponent,
  SvgDefinitionsComponent,
  SbTagEntitiesComponent,
  TrackerDetailsOverviewComponent,
  TrackerDetailsTrackedVisitorsComponent,
  TrackerComponent,
  TrackerCreationComponent,
  TrackerDetailsComponent,
  ScheduleLevelEditComponent,
  SbPageActionComponent,
  SbToggleSwitchComponent,
  SbProgressbarComponent,
  SbInfoTextComponent,
  SbExportModalComponent,
  SbDateTimeRangeInputComponent,
  ClientUserEditModalComponent,
  AdminMembershipComponent,
  SbPlanningContentShareComponent,
  BackgroundWorkerComponent,
];

const ANGULAR_IMPORTS = [AppRoutingModule, BrowserAnimationsModule, BrowserModule, CommonModule, FormsModule, ReactiveFormsModule];

const CDK_IMPORTS = [CdkTableModule, DragDropModule, ScrollingModule];

const MATERIAL_IMPORTS = [MatTableModule];

const BOOTSTRAP_IMPORTS = [NgbModule];

const GEO_IMPORTS = [LeafletDrawModule.forRoot(), LeafletModule.forRoot()];

const IMPORTS = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useClass: WebpackTranslateLoader,
    },
  }),
  ANGULAR_IMPORTS,
  BOOTSTRAP_IMPORTS,
  CDK_IMPORTS,
  MATERIAL_IMPORTS,
  GEO_IMPORTS,
  // SEATBACK_IMPORTS,
  ColorPickerModule,
  IconModule,
  EmailEditorModule,
];

@NgModule({
  declarations: [
    AppComponent,
    DIRECTIVES,
    PIPES,
    PAGES,
    MODALS,
    MODAL_COMPONENTS,
    COMPONENTS,
    SbCommercialEditorComponent,
    SbCommercialEditorFormsComponent,
    AttributesComponent,
    AttributeEditComponent,
    MediumGroupSettingsEditComponent,
    SbBookingEditorSortersComponent,
    PoolEditComponent,
    SbBookingStatusComponent,
    SbMediumGroupOverrideModalComponent,
    SbCampaignOrderingComponent,
    SbCommercialConflictListComponent,
    NotificationsComponent,
    SbNotificationListComponent,
    SbCommercialEditorRequirementsComponent,
    UserProfileComponent,
    UserProfileOverviewComponent,
    UserProfileSecurityComponent,
    UserProfilePermissionsComponent,
    UserProfileSettingsComponent,
    ToasterComponent,
    UserProfilePictureUploadComponent,
    SbDeviceOnlineStatusComponent,
    SbDeviceOnlineStatusIconComponent,
    SbCampaignPreviewSliderComponent,
    DeviceDetailsOverviewComponent,
    DeviceDetailsAttributesComponent,
    DeviceDetailsPlayoutsComponent,
    DeviceDetailsPositionsComponent,
    DeviceDetailsLogComponent,
    DeviceDetailsPlaylistsComponent,
    DeviceDetailsSetlistsComponent,
    DeviceDetailsPlaybackScheduleComponent,
    DeviceDetailsActivityComponent,
    SharedPlaybackSchedulesComponent,
    DeviceDetailsContentShareComponent,
    DeviceDetailsGeoStatsComponent,
    CompanyDetailsComponent,
    CompanyDetailsOverviewComponent,
    CompanyDetailsLocationsComponent,
    CompanyDetailsAttributesComponent,
    SbEmbeddedMediaComponent,
    SbEmbeddedMediumGroupsComponent,
    SbEmbeddedCampaignsComponent,
    SbLocationOnlineStatusComponent,
    CompanyDetailsCampaignsComponent,
    CompanyDetailsMediaComponent,
    CompanyDetailsMediumGroupsComponent,
    CompanyDetailsAreasComponent,
    CompanyDetailsCullsComponent,
    CampaignTypesComponent,
    CampaignTypeEditComponent,
    SbShareOfVoiceComponent,
    ShareOfVoiceContentComponent,
    SbAccessibleClientsComponent,
    FilterOverviewComponent,
    SbBooleanTogglesComponent,
    SbPaginationComponent,
    SbUncaughtModalComponent,
    SbForbiddenModalComponent,
    ShareOfVoiceOverviewComponent,
    SbProgressbarWrapperComponent,
    ErrorComponent,
    FilterDetailsComponent,
    ViewSettingComponent,
    OrderByPipe,
    AirtimeDataComponent,
    HeatmapStatusComponent,
    AirtimeComponent,
    PlayerReportingComponent,
    LocationComponent,
    PlayerHeaderComponent,
    AirtimeHeaderComponent,
    LocationHeaderComponent,
    SbChartControlComponent,
    SbLocalDateRangeInputComponent,
    SbAtomTypeGroupsWrapperComponent,
    NetworkShareEditComponent,
    NetworkShareDetailsComponent,
    InfoCardComponent,
    SbTagsComponent,
    TagsComponent,
    TagEditComponent,
    SbCommentComponentComponent,
    SbAvatarComponent,
    SbDiscussionComponentComponent,
    SbDiscussionSubtitleComponent,
    SbCompDiscussionMainPostComponent,
    SbDiscussionComponent,
    SbTopicEditComponent,
    ImageCropperComponent,
    ImageUploadComponent,
    ImageUploadModalComponent,
    TutorialHighlightComponent,
    SbAggregationReportComponent,
    ProductsComponent,
    ProductsEditComponent,
    ProductCategoriesComponent,
    ProductCategoriesEditComponent,
    ProductDetailsComponent,
    ProductDetailsOverviewComponent,
    ProductDetailsAttributesComponent,
    ProductDetailsCategoriesComponent,
    MediumTemplatePreviewComponent,
    TemplateGroupsComponent,
    ContentEditorListComponent,
    ContentEditorComponent,
    ContentCreatorComponent,
    SbBookableMarkersComponent,
    PlayerHardwareComponent,
    PlayerSoftwareComponent,
    SbTableWrapperNewComponent,
    SbTableWrapperComponent,
    TemplateSourceComponent,
    TemplateSourceEditComponent,
    MediumCardEntryComponent,
    MediumListEntryComponent,
    MediumEditComponent,
    SbFilterGeoCullComponent,
    ImageViewerComponent,
    TemplateSourceEntriesComponent,
    TemplateSourceEntryEditComponent,
    SbLevelDropdownComponent,
    SbTableButtonsComponent,
    SbPricingModalComponent,
    SbPlaylistPreviewComponent,
    SSPContractsComponent,
    DealsComponent,
    SSPContractCreationComponent,
    DealCreationComponent,
    SSPSComponent,
    LocationTrackerComponent,
    VisitorTrackerChartComponent,
    SbBookingEditorMediumSelectionComponent,
    InventoryWrapperComponent,
    InventoryCartComponent,
    InventoryListComponent,
    InventorySublistComponent,
    InventoryDetailsComponent,
    InventoryScopeSelectComponent,
    NetworkBookingsListComponent,
    SbMarkerListComponent,
    TrackerValuesElementComponent,
    TrackerValuesElementEditComponent,
    TrackerValuesLineComponent,
    SbDropdownSelectComponent,
    SbStringDropdownSelectComponent,
    PlayerHardwareEditComponent,
    PlayerSoftwareEditComponent,
    PlayerHardwareDetailsComponent,
    PlayerHardwareDetailsOverviewComponent,
    ScreenHardwareComponent,
    SbDeviceOnlineStatusCardComponent,
    SbImageNameWrapperComponent,
    SbNameWrapperComponent,
    SbLinkComponent,
    SbMediumComponent,
    AttachmentExplorerComponent,
    SbSidePanelComponent,
    AttachmentEditComponent,
    AttachmentLinkComponent,
    LocationAttachmentsComponent,
    AttachmentUrlComponent,
    AttachmentPreviewComponent,
    FileDummyComponent,
    AttachmentUploadComponent,
    MediumUploadComponent,
    FileUploadComponent,
    AttachmentCardEntryComponent,
    SbTagLookupsComponent,
    AttachmentFileComponent,
    AttachmentListEntryComponent,
    DeviceAttachmentsComponent,
    AttachmentUrlUploadComponent,
    SbDeviceRebootComponent,
    SbDeviceExitPlayerComponent,
    AdminUserSetRestoreCodeComponent,
    SbDiscussionMentionsComponent,
    SbLocalDateTimeRangeInputComponent,
    ScreenHardwareEditComponent,
    LocationTrackerAssignmentComponent,
    LocationTrackerAssignmentToScreensComponent,
    TrackerStatusComponent,
    LocationTrackerAssignmentToTrackerComponent,
    NoticeBoxComponent,
    QueryPerformanceComponent,
    EndpointPerformanceComponent,
    SbPasswordRequirementComponent,
    SbPlanningCommercialComponent,
    SbPartialPlanningComponent,
    SbPlanningTimeComponent,
    SbPeakChartComponent,
    GeneratedReportsComponent,
    StatisticCardComponent,
    SbCountrySelectComponent,
    AddressComponentComponent,
    WeeklyScheduleListComponent,
    WeeklyScheduleEditComponent,
    WeeklyScheduleComponent,
    SbSpecialOpeningHoursInputComponent,
    SbTimeInputComponent,
    StatisticCardComponent,
    ClientSelectionComponent,
    UploadingElementComponent,
    ColorsComponent,
    ColorEditComponent,
    ReportingFileComponent,
    ReportingModalComponent,
    TimeTypesComponent,
    TimeTypeEditComponent,
    GeneratedReportsListComponent,
    WebSettingsComponent,
    ClientOverviewComponent,
    ClientUserManagementComponent,
    ClientRoleManagementComponent,
    ClientInvitationsComponent,
    ClientConnectionsComponent,
    ConnectClientComponent,
    SbCommercialCountComponent,
    WebSettingComponent,
    CreateClientConnectionComponent,
    IncomingClientConnectionsTableComponent,
    SendClientConnectionsTableComponent,
    RepositoriesListComponent,
    AssetListComponent,
    AssetEditComponent,
    RepositoriesEditComponent,
    AssetCategoryListComponent,
    AssetCategoryEditComponent,
    MediumGroupCategoryListComponent,
    MediumGroupCategoryEditComponent,
    SelectionComponent,
    AssetExplorerComponent,
    AdminClientLicencesComponent,
    LicenceManagementGenerateModalComponent,
    LicenceManagementCopySerialModalComponent,
    SbClipboardListInputModalComponent,
    LicenceManagementAutoAssignModalComponent,
    SbClipboardListInputComponent,
    SharedAssetComponent,
    DebugVersionComponent,
    ReservationListComponent,
    ReservationComponent,
    ReservationEditComponent,
    SbFilterContentCullComponent,
    SlotOrderComponent,
    SbNetworkShareOptionStatusComponent,
    CullCategoriesComponent,
    CullCategoryEditComponent,
    TemplateDatasetComponent,
    TemplateDatasetEditComponent,
    TemplateDatasetEntriesComponent,
    TemplateDatasetEntryEditComponent,
    SbTemplateDataSetSelectModalComponent,
    RoleEditModalComponent,
    ClientUserEditModalComponent,
    DeviceDetailsScreensComponent,
    PlaylistSchemaComponent,
    AggregatedPlaylistSchemaComponent,
    TargetingComponent,
    TargetingEditComponent,
    TargetingOverviewComponent,
    SbDeviceLocalDataComponent,
    SbDeviceLocalSettingComponent,
    SbDevicePlaylistCache,
    SbDeviceCalibrationComponent,
    MediumTransformationListComponent,
    TargetedBookingSetComponent,
    RenderedTemplatesComponent,
    RenderedGroupsComponent,
    PlayoutAggregationComponent,
    QuotasComponent,
    SharedContentSharesComponent,
    SharedNetworkAccessComponent,
    DeviceDetailsNetworkAccessComponent,
    DeviceDetailsNetworkBookingsComponent,
    ContentShareComponent,
    SingleQuotaComponent,
    DropdownSelectItemComponent,
    ContentShareEditComponent,
    ValidityRangeDisplayComponent,
    SubmissionCountDisplayComponent,
    AdvertiserShareOfVoiceComponent,
    ApiKeyListComponent,
    ApiKeyEditComponent,
    DisplayCreatedComponent,
    DisplayModifiedComponent,
    RoutingTestComponent,
    DynamicTableElementComponent,
    TableMultiSelectButtonComponent,
    TableSelectButtonComponent,
    ColumnOptionComponent,
    KiComponent,
    KiHistoryComponent,
  ],
  imports: [LIB_ENTRY, IMPORTS, NgScrollbarModule],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: ErrorHandler, useClass: UncaughtHandler },
    { provide: TitleStrategy, useClass: SbPageTitleStrategy },
    // { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    // {provide: NgbDateAdapter, useClass: NgbStringAdapter},
    httpInterceptorProviders,
    API,
    APIService,
    AiAPI,
    AiAPIService,
    ConversionService,
    AdminService,
    ChangelogService,
    ErrorService,
    GeoAssetsService,
    GeoCodingService,
    GeoUtilService,
    ImageUploadService,
    ModalService,
    NotificationService,
    RouteGuardAdminService,
    RouteGuardService,
    SbModalState,
    SbPageActionService,
    TutorialHighlightService,
    UserService,
    UtilService,
    ContentEditorService,
    QueryParamService,
    DeviceService,
    CampaignReportingService,
    CampaignReportingObsService,
    AttachmentService,
    BookingService,
    CommercialReservationService,
    FilterStorageService,
    StorageService,
    UserSettingStorageService,
    UserSettingService,
    StringTransformationService,
    DateTransformationService,
    KiService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    injector: Injector,
    private readonly sbIconRegistry: IconService
  ) {
    customElements.define('sb-campaign-overview', createCustomElement(SbCampaignOverviewComponent, { injector }));
    customElements.define('sb-commercial-row', createCustomElement(SbCommercialRowComponent, { injector }));
    customElements.define('sb-commercial-overview', createCustomElement(SbCommercialOverviewComponent, { injector }));
    customElements.define('sb-event-tooltip', createCustomElement(SbEventTooltipComponent, { injector }));
    customElements.define('sb-medium-group-proxy', createCustomElement(SbMediumGroupProxyComponent, { injector }));
    customElements.define('sb-commercial-editor', createCustomElement(SbCommercialEditorComponent, { injector }));
    customElements.define('sb-booking-editor-sorters', createCustomElement(SbBookingEditorSortersComponent, { injector }));

    this.sbIconRegistry.registerIcons(ICONS_IMPORT);
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
